const translations = {
  "en": {
    "%{var0} day ago": "%{var0} day ago",
    "%{var0} days ago": "%{var0} days ago",
    "%{var0}h ago": "%{var0}h ago",
    "%{var0}m ago": "%{var0}m ago",
    "%{var0}s ago": "%{var0}s ago",
    "unlocked the latest Earnings Forecast": "unlocked the latest Earnings Forecast",
    "unlocked the latest Edgen's Pick": "unlocked the latest Ed's Pick",
    "unlocked the latest IPO Strategies": "unlocked the latest IPO Strategies"
  },
  "zh-tw": {
    "%{var0} day ago": "%{var0} 天前",
    "%{var0} days ago": "%{var0} 天前",
    "%{var0}h ago": "%{var0}小時前",
    "%{var0}m ago": "%{var0}分鐘前",
    "%{var0}s ago": "%{var0}秒前",
    "unlocked the latest Earnings Forecast": "解鎖最新財報預測",
    "unlocked the latest Edgen's Pick": "解鎖了最新的 Ed 精選",
    "unlocked the latest IPO Strategies": "解鎖最新 IPO 策略"
  }
};

export default translations;
